export default function GroupDetails({ selectedGroup, fields, formatColumnName, formatValue }) {
  return (
              <div className="smPost">
                <div className="smPostHeader">
                  <div className="smPostTitle Content-SemiBold">
                    Group Details
                  </div>
                </div>
                <div className="smGrid2">
                  {fields.map((field) => (
                    <div key={field} className="smRow">
                      <div className="smRowLabel Content-Small">
                        {formatColumnName(field)}
                      </div>
                      <div className="smRowValue Content">
                        {formatValue(selectedGroup?.[field]) || "-"}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
  );
}
